module.exports = __webpack_public_path__ + "img/edit-button.a49ad77f.svg";